import { render, staticRenderFns } from "./jiangxuejin.vue?vue&type=template&id=307db10c&scoped=true&"
import script from "./jiangxuejin.vue?vue&type=script&lang=js&"
export * from "./jiangxuejin.vue?vue&type=script&lang=js&"
import style0 from "./jiangxuejin.vue?vue&type=style&index=0&id=307db10c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307db10c",
  null
  
)

export default component.exports